export enum AblyGoodsCardChipType {
  AblyPurchase = 'ABLY_PURCHASE',
  New = 'NEW_GOODS',
  Brand = 'BRAND',
  Shoppingmall = 'SHOPPINGMALL',
  DittoText = 'DITTO_TEXT',
  DittoImage = 'DITTO_IMAGE',
}
